import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, FormControl, FormGroup, ControlLabel } from 'react-bootstrap';
import * as ProductActions from 'redux/modules/products';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		user: state.auth.user,
		adminChangeGSMLoading: state.products.adminChangeGSMLoading,
		adminChangeGSMError: state.products.adminChangeGSMError,
		adminChangeGSMSuccess: state.products.adminChangeGSMSuccess
	}),
	dispatch => bindActionCreators({ ...ProductActions }, dispatch)
)
export default class AdminChangeGSM extends Component {

	constructor(props) {
		super(props);
		this.state = {
			newGSM: '',
			showForm: false,
			validationError: null
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.validateGSM = this.validateGSM.bind(this);
	}

	handleChange(e) {
		const { t } = this.props;
		const value = e.target.value;
		let validationError = null;
		if (value.trim() !== '' && !this.validateGSM(value)) {
			validationError = t('validations.international_num') || 'Format invalide. Ex: +33612345678';
		}
		this.setState({ newGSM: value, validationError });
	}

	validateGSM(value) {
		const re = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,20}$/;
		return re.test(value);
	}

	handleSubmit() {
		const { t } = this.props;
		if (this.state.newGSM.trim() === '') {
			return;
		}
		if (!this.validateGSM(this.state.newGSM)) {
			this.setState({ validationError: t('validations.international_num') || 'Format invalide. Ex: +33612345678' });
			return;
		}
		this.props.adminChangeGSM(
			this.props.siteId,
			this.state.newGSM,
			this.props.urlParams
		).then(() => {
			this.setState({ newGSM: '', showForm: false });
			this.props.reloadForm();
		}).catch(() => {});
	}

	render() {
		const { t, user, adminChangeGSMLoading, adminChangeGSMError, adminChangeGSMSuccess } = this.props;

		if (user.role !== 'admin') {
			return null;
		}

		return (
			<div style={{ marginTop: '10px', marginBottom: '10px' }}>
				{!this.state.showForm ? (
					<Button 
						bsStyle="warning" 
						bsSize="sm"
						onClick={() => this.setState({ showForm: true })}
					>
						<i className="fa fa-key" /> {t('adminChangeGSM.change_sim_admin') || 'Changer N° SIM (Admin)'}
					</Button>
				) : (
					<div style={{ padding: '10px', border: '1px solid #f0ad4e', borderRadius: '4px', backgroundColor: '#fcf8e3' }}>
						<FormGroup style={{padding: '10px'}}>
							<ControlLabel>{t('adminChangeGSM.new_sim_number') || 'Nouveau N° SIM'}</ControlLabel>
							<FormControl
								type="text"
								value={this.state.newGSM}
								onChange={this.handleChange}
								placeholder={t('adminChangeGSM.enter_new_number') || 'Entrez le nouveau numéro'}
								disabled={adminChangeGSMLoading}
							/>
						</FormGroup>

						<Button 
							bsStyle="success" 
							onClick={this.handleSubmit}
							disabled={adminChangeGSMLoading || this.state.newGSM.trim() === '' || this.state.validationError}
							style={{ marginRight: '5px' }}
						>
							{adminChangeGSMLoading ? (
								<span><i className="fa fa-spinner fa-spin" /> {t('main.loading') || 'Chargement...'}</span>
							) : (
								<span><i className="fa fa-check" /> {t('main.validate') || 'Valider'}</span>
							)}
						</Button>

						<Button 
							bsStyle="default" 
							onClick={() => this.setState({ showForm: false, newGSM: '' })}
							disabled={adminChangeGSMLoading}
						>
							{t('main.cancel') || 'Annuler'}
						</Button>

						{this.state.validationError && (
							<Alert bsStyle="danger" style={{ marginTop: '10px' }}>
								{this.state.validationError}
							</Alert>
						)}

						{adminChangeGSMError && (
							<Alert bsStyle="danger" style={{ marginTop: '10px' }}>
								{adminChangeGSMError}
							</Alert>
						)}

						{adminChangeGSMSuccess && (
							<Alert bsStyle="success" style={{ marginTop: '10px' }}>
								{t('adminChangeGSM.success') || 'Numéro SIM modifié avec succès. Vous pouvez maintenant faire "Nouveau GSM".'}
							</Alert>
						)}
					</div>
				)}
			</div>
		);
	}
}
